// Wraps headlines to a given number of characters, makes length of lines as equal as it is possible without using
// justification and tries to make first line the longest.
// If there is a word that is larger than the given limit, the word is broken apart
// Params: Input string + Optional: number of characters at which the string will be wrapped (default: 50)
// Returns: Given string wrapped at the specified length
function wrapTitle(s, limit) {

	limit = (typeof limit === 'undefined') ? 50 : limit;

	var len = s.length;

	if (len <= limit) {
	
		return s;

	} else if (limit < len && len <= limit * 2) {

		var middle = Math.ceil(s.length / 2);
		var before = s.lastIndexOf(' ', middle + 1);
		var after = s.indexOf(' ', middle + 2);

		if (after != -1 && after <= limit) {
			middle = after;
		} else if (before != -1) {
			middle = before;
		}

		var s1 = s.substr(0, middle);
		var s2 = s.substr(middle + 1);

		if (s2.length > limit) {
			s2 = wrapToWidth(s2, middle);
		}

		return s1 + '<br>' + s2;

	} else {

		var newS = wrapToWidth(s,limit);
		return newS;

	}
}

// Wraps string to a given number of characters
// If there is a word that is larger than the given width, the word is broken apart
// Params: Input string + Optional: number of characters at which the string will be wrapped (default: 50)
// Returns: Given string wrapped at the specified length
function wrapToWidth(s,limit) {

	limit = (typeof limit === 'undefined') ? 50 : limit;

	var len = s.length;

	if (len <= limit) {
		return s;

	} else {

		var breakInChar = s.lastIndexOf(' ', limit);

		if (breakInChar != -1) {
			var s1 = s.substr(0, breakInChar);
			var s2 = s.substr(breakInChar + 1);
		} else {
			var s1 = s.substr(0, limit);
			var s2 = s.substr(limit + 1);
		}

		lengthS2 = s2.length;

		while (lengthS2 > limit) { 
			s2 = wrapToWidth(s2,limit);
		}

		return s1 + '<br>' + s2;

	}


}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
